import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { fetchTemperatureAlerts } from "../../../redux/api/raports.api";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getTemperatureAlertsTableTableData,
  temperatureAlertsTableHeader,
} from "./components/tableConfigs/temperatureAlertsTableConfig";
import TemperatureAlertsActionButtons from "./components/ActionButtons/TemperatureAlertsActionButtons";
import SolveTemperatureAlertModal from "./components/SolveTemperatureAlertModal";

function TemperatureAlerts() {
  const dispatch = useAppDispatch();
  const {
    raports: {
      temperatureAlerts: {
        data: { data: temperatureAlertsData, total: totalTemperatureAlerts },
        isLoading: isLoadingTemperatureAlerts,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableFilter
    ) {
      dispatch(
        fetchTemperatureAlerts({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          status: action.tableFilter.status,
        }),
      );
    }
  };

  return (
    <>
      <SolveTemperatureAlertModal />

      <TableWidget
        tableTitle="Alerte temperatura"
        tableHeaderData={temperatureAlertsTableHeader}
        tableItemsData={getTemperatureAlertsTableTableData(
          temperatureAlertsData,
        )}
        totalItems={totalTemperatureAlerts}
        tableLoading={isLoadingTemperatureAlerts}
        handleTableActions={handleTableActions}
        ActionButtonsComponent={TemperatureAlertsActionButtons}
        borderedRow
      />
    </>
  );
}

export default TemperatureAlerts;
